export default __webpack_public_path__ + "static/media/google-login.326789cb.svg";